import React, { useContext, useEffect } from 'react'
import { AuthContext } from '../../App'
import TabNav from '../../ui/TabNav/TabNav'
import { Switch } from 'react-router-dom'
import { Route } from 'react-router-dom'
import OrdersList from './components/OrdersList/OrdersList'

function Orders() {
  const { setPageTitle } = useContext(AuthContext)
  useEffect(() => {
    setPageTitle('Замовлення')
  }, [setPageTitle])

  const tabNavLinks = [
    { title: 'Замовлення', path: '/orders/list' },
    // { title: 'Категорії', path: '/products/categories' },
    // { title: 'Товари', path: '/products/list' },
    // { title: 'Фільтри', path: '/products/filters' },
  ]

  return (
    <>
      <TabNav links={tabNavLinks}></TabNav>
      <div className="Orders">
        <Switch>
          <Route path={['/orders/list/:orderId', `/orders/list`]} render={() => <OrdersList />} />
        </Switch>
      </div>
    </>
  )
}

export default Orders
